import React from "react";
import '../App.css';
import '../nav/Nav-Header'
import AlertsBox from "../cards/Recent-Alerts";
import 'bulma/css/bulma.min.css';
import {Container, Columns, Notification, Button, Heading} from 'react-bulma-components';
import PoliceHeader from "../nav/Police-Header";
import {Link} from "react-router-dom";
import PoliceMapBox from "../maps/Police-Map";


function PoliceHome() {
    return (

        <div className="App">
            <PoliceHeader/>

            <Container className={"is-fluid"} style={{
                top: '8vh',
                width: '90%'
            }}>
                <Columns>
                    <Columns.Column className={"is-half"}>
                        <AlertsBox type="Police Alert"/>
                    </Columns.Column>

                    <Columns.Column>
                        <div>
                            <Columns>
                                <Columns.Column>
                                    <PoliceMapBox />
                                </Columns.Column>
                            </Columns>
                        </div>
                    </Columns.Column>
                </Columns>

                <Columns.Column>
                    <div className={"has-text-centered"}>
                        <Link to="/">
                            <Button color="danger" size="medium">
                                <span>Go Back</span><br/>
                            </Button>
                        </Link>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <Link to="/data">
                            <Button color="primary" size="medium">
                                <span>View Users' Data</span><br/>
                            </Button>
                        </Link>
                    </div>
                </Columns.Column>
                <br/>
            </Container>
        </div>
    );
}

export default PoliceHome;
